import type { ReactNode } from 'react'
import { Inbox } from 'lucide-react'

interface EmptyStateProps {
  title?: string
  description?: string
  icon?: ReactNode
  action?: ReactNode
}

export function EmptyState({ title = 'No data', description, icon, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="text-zinc-300 mb-3">{icon ?? <Inbox size={40} />}</div>
      <p className="text-sm font-medium text-zinc-500">{title}</p>
      {description ? <p className="text-xs text-zinc-400 mt-1">{description}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  )
}
